import { useQuery } from '@tanstack/react-query'
import { useApiClient } from '@/api/client'
import type { NotificationTab, NotificationsResponse } from './types'

export const notificationKeys = {
  all: (slug: string) => ['notifications', slug] as const,
  list: (slug: string, tab: NotificationTab, page?: number) =>
    ['notifications', slug, 'list', tab, page ?? 0] as const,
  unreadCount: (slug: string) => ['notifications', slug, 'unread-count'] as const,
}

export function useNotifications(
  workspaceSlug: string,
  tab: NotificationTab,
  page = 0,
  limit = 50,
) {
  const { fetchWithAuth } = useApiClient()

  return useQuery({
    queryKey: notificationKeys.list(workspaceSlug, tab, page),
    queryFn: () =>
      fetchWithAuth<NotificationsResponse>(
        `/api/v1/workspaces/${workspaceSlug}/notifications?tab=${tab}&limit=${limit}&offset=${page * limit}`,
      ),
    staleTime: 30_000,
  })
}

export function useNotificationUnreadCount(workspaceSlug: string) {
  const { fetchWithAuth } = useApiClient()

  return useQuery({
    queryKey: notificationKeys.unreadCount(workspaceSlug),
    queryFn: () =>
      fetchWithAuth<{ count: number }>(
        `/api/v1/workspaces/${workspaceSlug}/notifications/unread-count`,
      ),
    staleTime: 60_000,
    refetchInterval: 60_000,
  })
}
